"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "tokenize", {
  enumerable: true,
  get: function get() {
    return _tokenizers.tokenize;
  }
});
Object.defineProperty(exports, "word", {
  enumerable: true,
  get: function get() {
    return _tokenizers.word;
  }
});
Object.defineProperty(exports, "punctuation", {
  enumerable: true,
  get: function get() {
    return _tokenizers.punctuation;
  }
});
Object.defineProperty(exports, "whitespace", {
  enumerable: true,
  get: function get() {
    return _tokenizers.whitespace;
  }
});
Object.defineProperty(exports, "number", {
  enumerable: true,
  get: function get() {
    return _tokenizers.number_;
  }
});
Object.defineProperty(exports, "normalizer", {
  enumerable: true,
  get: function get() {
    return _normalizers.normalizer;
  }
});
Object.defineProperty(exports, "normalizerDestructive", {
  enumerable: true,
  get: function get() {
    return _normalizers.normalizerDestructive;
  }
});
Object.defineProperty(exports, "normalizationsDestructive", {
  enumerable: true,
  get: function get() {
    return _normalizers.normalizationsDestructive;
  }
});
Object.defineProperty(exports, "occurrenceInString", {
  enumerable: true,
  get: function get() {
    return _occurrences.occurrenceInString;
  }
});
Object.defineProperty(exports, "occurrencesInString", {
  enumerable: true,
  get: function get() {
    return _occurrences.occurrencesInString;
  }
});
Object.defineProperty(exports, "selectionArray", {
  enumerable: true,
  get: function get() {
    return _selectionHelpers.selectionArray;
  }
});
Object.defineProperty(exports, "spliceStringOnRanges", {
  enumerable: true,
  get: function get() {
    return _selectionHelpers.spliceStringOnRanges;
  }
});
Object.defineProperty(exports, "selectionsToRanges", {
  enumerable: true,
  get: function get() {
    return _selectionHelpers.selectionsToRanges;
  }
});

var _tokenizers = require("./tokenizers");

var _normalizers = require("./normalizers");

var _occurrences = require("./occurrences");

var _selectionHelpers = require("./selectionHelpers");